import { maxBy } from "lodash-es";

import {
  createAppSelector,
  publicationSelectors,
  sectionSelectors,
  selectCurrentSectionId,
} from "./base";

import { isLinkedSection, isTemplateSection } from "utils/publishing";

// If the current section is a template section, return its own section ID.
// If the current section is a linked section, return the template section ID.
// Otherwise, return null.
export const selectTemplateSectionIdForCurrentSection = createAppSelector(
  [selectCurrentSectionId, sectionSelectors.selectEntities],
  (currentSectionId, sections) => {
    const section = currentSectionId ? sections[currentSectionId] : null;
    return section && isLinkedSection(section)
      ? section.template_id
      : isTemplateSection(section)
        ? currentSectionId
        : null;
  },
);

export const selectLatestPublicationForCurrentSection = createAppSelector(
  [
    (state) =>
      publicationSelectors.filterBySectionId(
        state,
        selectTemplateSectionIdForCurrentSection(state),
      ),
  ],
  (publications) => maxBy(publications, "version"),
);

export const selectLatestPublicationForSectionId = createAppSelector(
  [publicationSelectors.filterBySectionId],
  (publications) => maxBy(publications, "version"),
);
